import { Alert, Button, Box } from '@mui/material';
import { ExitToApp } from '@mui/icons-material';

interface ImpersonationBannerProps {
  impersonatedUserName: string;
  impersonatedUserEmail: string;
  onExit: () => void;
}

export const ImpersonationBanner = ({
  impersonatedUserName,
  impersonatedUserEmail,
  onExit
}: ImpersonationBannerProps) => {
  return (
    <Alert
      severity="warning"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 9999,
        borderRadius: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2
      }}
      action={
        <Button
          color="inherit"
          size="small"
          startIcon={<ExitToApp />}
          onClick={onExit}
          sx={{ whiteSpace: 'nowrap' }}
        >
          Exit Impersonation
        </Button>
      }
    >
      You are impersonating <strong>{impersonatedUserName}</strong> ({impersonatedUserEmail})
    </Alert>
  );
};
